module.exports = __webpack_public_path__ + "img/background.c1370c7.jpg";